<script setup lang="ts">
interface Props {
  message?: string;
  inline?: boolean;
}

withDefaults(defineProps<Props>(), {
  message: 'Loading...',
  inline: false,
});
</script>

<template>
  <div :class="inline ? 'flex items-center' : 'flex items-center justify-center p-8'">
    <div class="spinner"></div>
    <span class="ml-3 text-gray-600">{{ message }}</span>
  </div>
</template>
